import axios from 'axios';
import { isEvocalizeFeedProcessed, nextProcessRemainingHours } from '../utils/feedTimesValidations'

const initialState = {
  showIsProcessingDialog: false,
  userBoards: [],
};

const defaultBoard = 'LionDesk';

export default {
  namespaced: true,
  state: {
    ...initialState,
  },
  mutations: {
    setShowIsProcessingDialog(state, isProcessing) {
      state.showIsProcessingDialog = isProcessing;
    },
    setUserBoards(state, userBoards) {
      state.userBoards = userBoards
    },
  },
  getters: {
    getBoardsWithoutLionDesk: state => {
      return state.userBoards.filter(data =>
        data.mls_board != defaultBoard
      ).map(data => {  
        return data.mls_board
      });
    },
    hasSettingsSource: state => {
      return state.userBoards.some(data => {
        return data.source === 'settings'
      });
    },
    isInUsersFeed: state => {
      return state.userBoards.length > 0;
    },
    isUserProcessed: state => {
      if (!state.userBoards.length) return false;
      return state.userBoards.some(board => isEvocalizeFeedProcessed(board.created_at));
    },
    getFeedProcessRemainingHours : (state, getters, rootState) => {
      const createdAt = state.userBoards.length ? state.userBoards[0].created_at : new Date();
      return nextProcessRemainingHours(createdAt, rootState.userInformation.serverDate);
    },
    hasUserListingProcessed: state => {
      if(!state.userBoards.length) return false;
      return state.userBoards.some(board => {
        return board.mls_board !== defaultBoard
          ? isEvocalizeFeedProcessed(board.created_at)
          : false;
      });
    },
  },
  actions: {
    async getEvocalizeUserData({ commit }, currentUser) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_ACCOUNTS_API}/users/evocalize-users-feed/${currentUser}`);
        commit('setUserBoards', response.data);
      } catch (error) {
        console.log(error);
      }
    },
    async createEvocalizeUserData({ commit }, data) {
      try {
        await axios.post(`${process.env.VUE_APP_ACCOUNTS_API}/users/evocalize-users-feed`, data)
      } catch (error) {
        console.log(error);
      }
    },
  },
};

